var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9949 1.9993H1.99919C1.63113 1.9993 1.33276 2.29767 1.33276 2.66573V4.66502C1.33276 5.03308 1.63113 5.33145 1.99919 5.33145H13.9949C14.363 5.33145 14.6614 5.03308 14.6614 4.66502V2.66573C14.6614 2.29767 14.363 1.9993 13.9949 1.9993Z",
    stroke: "#BB4D00",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66577 5.33145V12.6622C2.66577 13.0157 2.8062 13.3547 3.05616 13.6047C3.30612 13.8546 3.64513 13.995 3.99863 13.995H11.9958C12.3493 13.995 12.6883 13.8546 12.9383 13.6047C13.1882 13.3547 13.3287 13.0157 13.3287 12.6622V5.33145",
    stroke: "#BB4D00",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66431 7.99716H9.33003",
    stroke: "#BB4D00",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9943,
    height: 15.9943,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/Box.53e6462ee29a87f4b338cf0bd0b5bce5.svg";
export { ForwardRef as ReactComponent };